import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        生徒の回答データは、内容ごとにPDFまたはCSVでダウンロード・印刷できます。該当するデータをご確認ください。
      </p>
    </div>
    <div>
      <p className={styles.heading}>
        ▶ CORE｜指導画面のメニュー［生徒個別データ］
      </p>
      <ul className={styles.list}>
        <li className={styles.item}>振り返りシート（PDF）</li>
        <li className={styles.item}>ワーク回答データ（CSV）</li>
        <li className={styles.item}>実践ワークシート※旧LEAF（PDF）</li>
      </ul>
    </div>
    <div>
      <p className={styles.heading}>
        ▶ 自己評価機能（旧GLIDE）｜先生メニュー［自己評価データ］
      </p>
      <ul className={styles.list}>
        <li className={styles.item}>自己評価データ（PDF）</li>
        <li className={styles.item}>回答データ（CSV）</li>
      </ul>
    </div>
  </div>
);

export const DOWNLOAD_STUDENT_ANSWERS_FAQ: FaqCategoryItem = {
  id: "download-student-answers-faq",
  question: "生徒の回答データをダウンロード・印刷したい",
  Answer,
};
